var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRoomsAcceptanceIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.084 11.045L16.7338 10.3952C18.4925 8.63649 21.3422 8.63649 23.1009 10.3952L29.8732 17.1675C32.0506 19.3449 32.0506 22.8744 29.8732 25.0518L29.5416 25.3835C27.3642 27.5609 23.8347 27.5609 21.6573 25.3835L16.3856 20.1118",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24919 21.7714C6.03277 20.6639 4.49463 18.3965 4.49463 15.7494C4.49463 12.0203 7.51839 8.99658 11.2474 8.99658C14.9765 8.99658 18.0003 12.0203 18.0003 15.7494C18.0003 18.395 16.4636 20.6624 14.2487 21.7699V21.7669L14.2472 28.5107C14.2457 28.9069 14.0881 29.2865 13.8075 29.5656L12.3039 31.0693C11.7186 31.653 10.7732 31.6515 10.1895 31.0678L8.68437 29.5596C8.40376 29.279 8.24619 28.8979 8.24619 28.5017L8.24919 21.7684",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2476 15.3742V8.62135C11.2476 6.3419 13.0948 4.49463 15.3743 4.49463V4.49463C17.6537 4.49463 19.501 6.3419 19.501 8.62135V9.09705",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2459 15.3742C11.0388 15.3742 10.8707 15.5422 10.8737 15.7493C10.8737 15.9564 11.0418 16.1245 11.2489 16.1245C11.456 16.1245 11.624 15.9564 11.624 15.7493C11.6225 15.5422 11.4545 15.3742 11.2459 15.3742",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoomsAcceptanceIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RoomsAcceptanceIcon.e7aedbb0.svg";
export { ForwardRef as ReactComponent };